import React from "react";
import UserManagementTable from "../../../components/table/all-tables/usermanagementtable/UserManagementTable";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../page-action/AccessPageAction";
import LoginAsUser from "../../../components/loginasuser/LoginAsUser";
import { userManage } from "../../../locales/en";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";

const UserManagement = () => {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle
        mainTitle={userManage?.mainTitle}
        content={userManage?.content}
      />
      <AccessPageAction
        subheading={userManage?.activeUser}
        alluser="/admin/access/user"
        allUserTitle={userManage?.activeUser}
        createuser="/admin/access/user/create"
        createUserTitle={userManage?.creteUser}
        deactivate="/admin/access/user/deactivated"
        deactivateTitle={userManage?.deactiveUserBtn}
        deleteuser="/admin/access/user/deleted"
        deleteUserTitle={userManage?.deleteUser}
      />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mb-3 mx-0">
          <div className="col-12">
            <UserManagementTable />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
};

export default UserManagement;
